import React, { useState } from "react";
import type { ApiHistory } from "../types";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { formatDate } from "@/utils/date";
import type { RowSelectionState } from "@tanstack/react-table";
import MobileListWrapper from "@/components/mobile-list-wrapper";
import { DateFormats } from "@/utils/date/constants";
import { getActionVariant } from "../utils";
import ChangesDialog from "./changes-dialog";

interface ListContentProps {
  data: ApiHistory[];
  isLoading: boolean;
  className?: string;
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  emptyListComponent: React.ReactElement;
  rowSelection?: RowSelectionState;
  onRowSelectionChange?: (selection: RowSelectionState) => void;
}

const ListContent = ({
  data,
  isLoading,
  className,
  page,
  pageCount,
  onPageChange,
  emptyListComponent,
  rowSelection,
  onRowSelectionChange,
}: ListContentProps) => {
  const { t } = useTranslation();
  const [selectedHistory, setSelectedHistory] = useState<ApiHistory | null>(
    null,
  );

  return (
    <>
      <MobileListWrapper
        data={data}
        isLoading={isLoading}
        className={className}
        page={page}
        pageCount={pageCount}
        onPageChange={onPageChange}
        emptyListComponent={emptyListComponent}
        rowSelection={rowSelection}
        onRowSelectionChange={onRowSelectionChange}
        onItemClick={(history) => setSelectedHistory(history)}
        renderItem={(history) => (
          <>
            <div className="flex items-center justify-between">
              <Badge variant="outline">
                {t(`keys.resources.${history.model_type}`)}
              </Badge>
              <Badge variant={getActionVariant(history.action_display)}>
                {t(`keys.action_types.${history.action_display}`)}
              </Badge>
            </div>
            <div className="flex items-center mt-2 justify-between">
              <span className="text-sm text-gray-500 truncate inline-block max-w-56">
                {history?.actor?.username ?? "-"}
              </span>
              <p className="text-sm text-gray-500">
                {formatDate(history.timestamp, DateFormats.UI_DATETIME_SHORT)}
              </p>
            </div>
          </>
        )}
      />
      {selectedHistory && (
        <ChangesDialog
          history={selectedHistory}
          trigger={null}
          open={!!selectedHistory}
          onOpenChange={(open) => {
            if (!open) setSelectedHistory(null);
          }}
        />
      )}
    </>
  );
};

export default ListContent;
